<template>
	<nav id="nav">
		<ul>
			<li><a href="#intro" class="active">Intro</a></li>
			<li><a href="#projects">Personal projects</a></li>
			<li><a href="#lang-and-tools">Languages and tools</a></li>
			<li><a href="#contacts">Contact</a></li>
		</ul>
	</nav>
</template>